import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "px-4 py-0"
};
const _hoisted_2 = { class: "mb-3" };
const _hoisted_3 = { class: "mb-4" };
const _hoisted_4 = { class: "mb-4 d-flex justify-content-between" };
const _hoisted_5 = { class: "mb-2" };
const _hoisted_6 = { class: "fw-bold" };
const _hoisted_7 = {
    key: 0,
    class: "d-block border-top mt-2"
};
const _hoisted_8 = { class: "mb-2" };
const _hoisted_9 = { class: "fw-bold" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { class: "mb-4" };
const _hoisted_12 = { class: "mb-3" };
const _hoisted_13 = {
    key: 0,
    class: "badge text-bg-danger fs-5"
};
const _hoisted_14 = {
    key: 1,
    class: "badge text-bg-success fs-5"
};
const _hoisted_15 = {
    key: 0,
    class: "me-3"
};
const _hoisted_16 = { class: "text-primary" };
const _hoisted_17 = {
    key: 1,
    class: "badge text-bg-success ms-3"
};
const _hoisted_18 = { class: "row" };
const _hoisted_19 = { class: "col-12 col-lg-6" };
const _hoisted_20 = ["href"];
const _hoisted_21 = { class: "ms-2" };
const _hoisted_22 = { key: 0 };
const _hoisted_23 = { class: "fs-5 fw-bold" };
const _hoisted_24 = ["onSubmit"];
const _hoisted_25 = { class: "form-check mb-3" };
const _hoisted_26 = ["id"];
const _hoisted_27 = ["for"];
const _hoisted_28 = {
    type: "submit",
    class: "btn btn-primary rounded-5 d-flex align-items-center"
};
const _hoisted_29 = { class: "ms-2" };
const _hoisted_30 = { key: 1 };
const _hoisted_31 = { class: "fs-5 fw-bold text-success m-0" };
const _hoisted_32 = {
    key: 2,
    class: "mt-5 small"
};
import axios from 'axios';
import { onMounted, ref } from 'vue';
import { observeDOMChanges, sendHeight } from '../Composables/iframeHeightCalculator';
import { cssStyleSheetLoader } from '../Composables/cssStyleSheetLoader';
import ConfiguratorLayout from '../Layouts/ConfiguratorLayout.vue';
import { router, usePage } from '@inertiajs/vue3';
import StandardLoadingDisplay from '@/Shared/StandardLoadingDisplay.vue';
import { Accordion, AccordionContent, AccordionHeader, AccordionPanel } from 'primevue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { useI18n } from 'vue-i18n';
import { useTrans } from '@/Composables/useTrans';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderApproval',
    props: {
        tenantId: String,
        componentUuid: String,
        orderUuid: {
            type: String,
            required: true
        },
        cssFileUrl: {
            type: String,
            default: null
        },
        configuratorUrl: {
            type: String,
            required: true
        },
        sessionId: {
            type: String,
            required: true
        },
        countries: {
            type: Object,
            required: true
        }
    },
    setup(__props) {
        let { loadCssStyleSheet } = cssStyleSheetLoader();
        let { showSuccessSwal, showErrorSwal } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const { t } = useI18n();
        const { trans } = useTrans();
        const props = __props;
        const cartKey = ref(Math.random().toString(36).substring(7));
        const user = ref(usePage().props.auth.user);
        const loading = ref(false);
        const order = ref();
        const showTaxIncludedPrices = ref(false);
        const approvedPrintConfigurationsAmount = ref(0);
        const initialAccordionPanel = ref(null);
        onMounted(async () => {
            if (props.cssFileUrl) {
                loadCssStyleSheet(props.cssFileUrl);
            }
            loadOrder();
            sendHeight();
            observeDOMChanges();
        });
        function loadOrder() {
            loading.value = true;
            axios.post(route('orders.externalApproval.load', {
                tenantId: props.tenantId,
                order_uuid: props.orderUuid,
            }))
                .then(function (response) {
                loading.value = false;
                order.value = response.data.order;
                approvedPrintConfigurationsAmount.value = response.data.order.printConfigurations.filter((printConfiguration) => printConfiguration.customerApprovedAt != null).length;
                order.value.printConfigurations.forEach((printConfiguration) => {
                    if (printConfiguration.customerApprovedAt == null && initialAccordionPanel.value == null) {
                        initialAccordionPanel.value = printConfiguration.uuid;
                    }
                });
                cartKey.value = Math.random().toString(36).substring(7);
            })
                .catch(function (error) {
                loading.value = false;
                console.error(error);
            });
        }
        function confirmDimensionSheet(dimensionSheetUuid) {
            router.post(route('orders.externalApproval.approve', dimensionSheetUuid), {}, {
                preserveScroll: true,
                onSuccess: page => {
                    initialAccordionPanel.value = null;
                    loadOrder();
                    showSuccessSwal(t('Vielen Dank! Ihre Freigabe wurde erfolgreich erteilt.'));
                },
                onError: errors => {
                    console.log(errors);
                    showErrorSwal(errors[0]);
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ConfiguratorLayout, null, {
                default: _withCtx(() => [
                    (order.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(trans)('Ihre Bestellung vom {date}', { date: _unref(formatDate)(order.value.createdAt) })), 1),
                            _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)('Freigabe Ihrer Druckaufträge')), 1),
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("h5", _hoisted_6, _toDisplayString(_unref(t)('Rechnungsanschrift')), 1),
                                        _createTextVNode(" " + _toDisplayString(order.value.invoiceAddress.company) + " ", 1),
                                        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                                        _createTextVNode(_toDisplayString(order.value.invoiceAddress.name) + " ", 1),
                                        _createElementVNode("span", null, [
                                            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                                            _createTextVNode(_toDisplayString(order.value.invoiceAddress.street) + " ", 1),
                                            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                                            _createTextVNode(_toDisplayString(order.value.invoiceAddress.zipcode) + " " + _toDisplayString(order.value.invoiceAddress.city) + " ", 1),
                                            _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                                            _createTextVNode(_toDisplayString(order.value.invoiceAddress.country), 1)
                                        ]),
                                        (order.value.customer)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                                _createTextVNode(_toDisplayString(order.value.customer.email) + " ", 1),
                                                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                                _createTextVNode(_toDisplayString(order.value.customer.phone), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("h5", _hoisted_9, _toDisplayString(_unref(t)('Lieferanschrift')), 1),
                                        _createTextVNode(" " + _toDisplayString(order.value.deliveryAddress.company) + " ", 1),
                                        _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                                        _createTextVNode(_toDisplayString(order.value.deliveryAddress.name) + " ", 1),
                                        (order.value.deliveryAddress)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                                                _createTextVNode(_toDisplayString(order.value.deliveryAddress.street) + " ", 1),
                                                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                                                _createTextVNode(_toDisplayString(order.value.deliveryAddress.zipcode) + " " + _toDisplayString(order.value.deliveryAddress.city) + " ", 1),
                                                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                                _createTextVNode(_toDisplayString(order.value.deliveryAddress.country), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("p", null, [
                                        _createElementVNode("strong", null, _toDisplayString(_unref(t)('Vielen Dank für Ihre Bestellung!')), 1)
                                    ]),
                                    _createElementVNode("p", null, _toDisplayString(_unref(t)('Um Ihre Bestellung abzuschließen, benötigen wir noch Ihre Freigabe für die nachfolgenden Druckaufträge.<br />Prüfen Sie bitte jeden Druckauftrag und bestätigen Sie die Freigabe, um Ihre Bestellung abzuschließen.')), 1),
                                    _createElementVNode("p", null, _toDisplayString(_unref(t)('Sollten Sie Fragen haben, wenden Sie sich bitte an unseren Support.')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    (approvedPrintConfigurationsAmount.value < order.value.printConfigurations.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(trans)('Sie müssen noch {count} von {total} Freigaben erteilen.', { count: order.value.printConfigurations.length - approvedPrintConfigurationsAmount.value, total: order.value.printConfigurations.length })), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(t)('Alle Freigaben wurden erteilt. Vielen Dank!')), 1))
                                ]),
                                _createVNode(_unref(Accordion), { value: initialAccordionPanel.value }, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.value.printConfigurations, (printConfiguration) => {
                                            return (_openBlock(), _createBlock(_unref(AccordionPanel), {
                                                key: printConfiguration.id,
                                                value: printConfiguration.uuid
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(AccordionHeader), { class: "d-flex align-items-center fs-4" }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("span", null, [
                                                                (printConfiguration.customerApprovedAt)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [...(_cache[9] || (_cache[9] = [
                                                                            _createElementVNode("svg", {
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                height: "24",
                                                                                fill: "currentColor",
                                                                                class: "bi bi-check2-circle text-success",
                                                                                viewBox: "0 0 16 16"
                                                                            }, [
                                                                                _createElementVNode("path", { d: "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" }),
                                                                                _createElementVNode("path", { d: "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" })
                                                                            ], -1)
                                                                        ]))]))
                                                                    : _createCommentVNode("", true),
                                                                _createElementVNode("span", _hoisted_16, _toDisplayString(printConfiguration.productName) + " - " + _toDisplayString(_unref(t)('Druck')) + " (" + _toDisplayString(printConfiguration.type) + ")", 1),
                                                                (printConfiguration.customerApprovedAt)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(t)('Freigabe erteilt am:')) + " " + _toDisplayString(_unref(formatDate)(printConfiguration.customerApprovedAt, true)) + " Uhr", 1))
                                                                    : _createCommentVNode("", true)
                                                            ])
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_unref(AccordionContent), null, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_18, [
                                                                _createElementVNode("div", _hoisted_19, [
                                                                    _createElementVNode("p", null, _toDisplayString(_unref(t)('Bitte laden Sie die Maßblatt-PDF zur Überprüfung herunter.')), 1),
                                                                    _createElementVNode("a", {
                                                                        href: _ctx.route('orders.externalApproval.dimensionSheets.download', printConfiguration.dimensionSheetUuid),
                                                                        target: "_blank",
                                                                        class: "btn btn-primary text-white d-inline-flex align-items-center mb-4"
                                                                    }, [
                                                                        _cache[10] || (_cache[10] = _createElementVNode("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            height: "16",
                                                                            fill: "currentColor",
                                                                            class: "bi bi-file-earmark-pdf",
                                                                            viewBox: "0 0 16 16"
                                                                        }, [
                                                                            _createElementVNode("path", { d: "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" }),
                                                                            _createElementVNode("path", { d: "M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" })
                                                                        ], -1)),
                                                                        _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)('PDF-Download')), 1)
                                                                    ], 8, _hoisted_20),
                                                                    (!printConfiguration.customerApprovedAt)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                                            _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(t)('Druckauftrag freigeben?')), 1),
                                                                            _createElementVNode("form", {
                                                                                onSubmit: _withModifiers(($event) => (confirmDimensionSheet(printConfiguration.dimensionSheetUuid)), ["prevent"])
                                                                            }, [
                                                                                _createElementVNode("div", _hoisted_25, [
                                                                                    _createElementVNode("input", {
                                                                                        class: "form-check-input",
                                                                                        type: "checkbox",
                                                                                        value: "1",
                                                                                        id: 'approveCheck' + printConfiguration.dimensionSheetUuid,
                                                                                        required: ""
                                                                                    }, null, 8, _hoisted_26),
                                                                                    _createElementVNode("label", {
                                                                                        class: "form-check-label",
                                                                                        for: 'approveCheck' + printConfiguration.dimensionSheetUuid
                                                                                    }, _toDisplayString(_unref(t)('Ich bestätige hiermit, dass ich die Druckvorschau geprüft habe und die Freigabe für diesen Druckauftrag erteile. Mir ist bewusst, dass nach der Freigabe keine Änderungen mehr möglich sind und die Produktion gestartet wird.')), 9, _hoisted_27)
                                                                                ]),
                                                                                _createElementVNode("button", _hoisted_28, [
                                                                                    _cache[11] || (_cache[11] = _createElementVNode("svg", {
                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                        width: "16",
                                                                                        height: "16",
                                                                                        fill: "currentColor",
                                                                                        class: "bi bi-check2-circle",
                                                                                        viewBox: "0 0 16 16"
                                                                                    }, [
                                                                                        _createElementVNode("path", { d: "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" }),
                                                                                        _createElementVNode("path", { d: "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" })
                                                                                    ], -1)),
                                                                                    _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('Freigabe erteilen')), 1)
                                                                                ])
                                                                            ], 40, _hoisted_24)
                                                                        ]))
                                                                        : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                                            _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(t)('Druckauftrag freigegeben')), 1)
                                                                        ]))
                                                                ])
                                                            ])
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                _: 2
                                            }, 1032, ["value"]));
                                        }), 128))
                                    ]),
                                    _: 1
                                }, 8, ["value"])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (loading.value)
                        ? (_openBlock(), _createBlock(StandardLoadingDisplay, {
                            key: 1,
                            infoText: _unref(t)('Bestellung wird geladen')
                        }, null, 8, ["infoText"]))
                        : _createCommentVNode("", true),
                    (user.value && !user.value.isCustomer)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(props.sessionId), 1))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
